module.exports = __webpack_public_path__ + "static/media/reckitt.3f909c7e.png";